/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Success_SavedInputs */

const he_profile_success_saved = /** @type {(inputs: Profile_Success_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפרופיל נשמר בהצלחה`)
};

const en_profile_success_saved = /** @type {(inputs: Profile_Success_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile saved successfully`)
};

/**
* | output |
* | --- |
* | "Profile saved successfully" |
*
* @param {Profile_Success_SavedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_success_saved = /** @type {((inputs?: Profile_Success_SavedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Success_SavedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_success_saved(inputs)
	return en_profile_success_saved(inputs)
});